<!-- Stands in for the buttons while the providers initialise. Each SDK settles at its own pace, so
     without this the row sits blank and the buttons then appear one at a time. -->
@if (initialising && hasProviders) {
  <div class="express-checkout-loading" role="status" aria-live="polite">
    <span class="express-checkout-loading__mark" aria-hidden="true">
      <svg class="express-checkout-loading__ring" viewBox="0 0 44 44" focusable="false">
        <circle class="express-checkout-loading__track" cx="22" cy="22" r="20" fill="none" stroke-width="2" />
        <circle
          class="express-checkout-loading__arc"
          cx="22"
          cy="22"
          r="20"
          fill="none"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
      <span class="material-icons express-checkout-loading__icon">add_card</span>
    </span>

    <span class="express-checkout-loading__label">{{
      'fgbcl.express.checkout.providers.loading' | translate: { fgbdefault: 'Loading card options' }
    }}</span>
  </div>
}

<div
  class="express-checkout-providers"
  [class.express-checkout--empty]="!hasProviders"
  [class.express-checkout-providers--initialising]="initialising"
>
  <!-- Each registered express checkout provider (e.g. Paze) is rendered here dynamically. -->
  <ng-container #providerHost></ng-container>
</div>
